import { validCoordinates } from "./locationValidation.js";

// A pin describes access/navigation, not a correction to a documentary address.
export function applyDirectoryMapPoint(saved, point) {
  const inferred = point.lookupFailed ? {} : point;
  const inferAddress = !String(saved.streetName || "").trim();
  return {
    ...saved,
    latitude: point.lat, longitude: point.lng,
    streetName: saved.streetName || inferred.address || "",
    cityName: saved.cityName || (inferAddress ? inferred.cityName : "") || "",
    postalCode: saved.postalCode || (inferAddress ? inferred.postalCode : "") || "",
    countryCode: saved.countryCode || inferred.countryCode || "",
  };
}

export function applyCheckpointMapPoint(saved = {}, point) {
  const inferred = point.lookupFailed ? {} : point;
  const inferAddress = !String(saved.address || "").trim();
  return {
    ...saved, lat: point.lat, lng: point.lng,
    address: saved.address || inferred.address || "",
    name: saved.name || inferred.name || inferred.address || "",
    cityName: saved.cityName || (inferAddress ? inferred.cityName : "") || "",
    postalCode: saved.postalCode || (inferAddress ? inferred.postalCode : "") || "",
    countryCode: saved.countryCode || inferred.countryCode || "",
    placeId: "",
  };
}

export function applyCheckpointAddressResult(saved = {}, point, address) {
  const hasPin = validCoordinates(saved.lat, saved.lng);
  return {
    ...saved,
    address: point.address || address || saved.address || "",
    lat: hasPin ? saved.lat : point.lat,
    lng: hasPin ? saved.lng : point.lng,
    cityName: point.cityName || saved.cityName || "",
    postalCode: point.postalCode || saved.postalCode || "",
    countryCode: point.countryCode || saved.countryCode || "",
    placeId: "",
  };
}
